/* unplugin-vue-components disabled */import { render } from "./备份版本.vue?vue&type=template&id=38a5697e&scoped=true"
import script from "./备份版本.vue?vue&type=script&lang=js"
export * from "./备份版本.vue?vue&type=script&lang=js"

import "./备份版本.vue?vue&type=style&index=0&id=38a5697e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a5697e"]])

export default __exports__